<template>
  <div class="bg-pattern"></div>
  <ErrorNotification
    :message="errorMessage"
    @close="clearError"
  />
  <OnboardingModal
    v-model="showOnboardingModal"
  />
  <div v-if="isInitializing" class="initial-loading">
    <LoadingSpinner size="lg" />
  </div>
  <main v-else class="app-main">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import ErrorNotification from './components/ErrorNotification.vue'
import OnboardingModal from './components/onboarding/OnboardingModal.vue'
import LoadingSpinner from './components/common/LoadingSpinner.vue'

export default defineComponent({
  name: 'App',
  components: {
    ErrorNotification,
    OnboardingModal,
    LoadingSpinner,
  },
  setup() {
    const store = useStore()
    const errorMessage = computed(() => store.state.error as string | null)
    const isInitializing = computed(() => store.state.isInitializing as boolean)

    const showOnboardingModal = computed({
      get: () => store.state.showOnboardingModal,
      set: (value: boolean) => store.commit('SET_SHOW_ONBOARDING_MODAL', value),
    })

    const clearError = () => {
      store.commit('SET_ERROR', null)
    }

    return {
      errorMessage,
      showOnboardingModal,
      isInitializing,
      clearError,
    }
  },
})
</script>

<style scoped>
.initial-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-base);
  z-index: var(--z-modal);
}

.initial-loading :deep(.loading-spinner) {
  color: var(--interactive-primary);
}
</style>
